<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" :width="1000">
    <table class="QHtable" v-if="show">
      <tr>
        <th style="width: 150px">基本信息</th>
        <th colspan="10">
          <QHButton A="A74" size="default" @Tap="$refs.edit.hiUpdete(row)" style="float: right" title="信息修改" v-if="isAuth"> 信息修改 </QHButton>
        </th>
      </tr>
      <tr>
        <td><b>车厢编号</b></td>
        <td>{{ row.NO }}</td>
        <td style="width: 150px; text-align: center"><b>车厢名称</b></td>
        <td>{{ row.name }}</td>
      </tr>
      <tr>
        <td><b>所属公司</b></td>
        <td>{{ row.orgName }}</td>
        <td style="text-align: center"><b>状态</b></td>
        <td>
          <span v-if="row.status == 100">待使用</span>
          <span v-if="row.status == 200">使用中</span>
          <span v-if="row.status == 300">已停用</span>
        </td>
      </tr>
      <tr>
        <td><b>车厢长度</b></td>
        <td>{{ row.length }}</td>
        <td style="text-align: center"><b>车厢宽度</b></td>
        <td>{{ row.width }}</td>
      </tr>
      <tr>
        <td><b>车厢高度</b></td>
        <td>{{ row.height }}</td>
        <td style="text-align: center"><b>车厢载量</b></td>
        <td>{{ row.specifications }}</td>
      </tr>
     
      <!-- 资质证件部分保持不变 -->
      <tr>
        <th>资质证件</th>
        <th colspan="10">
          <QHButton A="A222" size="default" style="float: right" @Tap="$refs.setQualification.hiCreated(row.id, 700)" v-if="isAuth"> 资质上传 </QHButton>
        </th>
      </tr>
      <tr v-if="!row.information700">
        <td colspan="10">暂无证件资质信息</td>
      </tr>
      <tr v-for="(item, index) in row.information700" :key="index">
        <td>
          <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
        </td>
        <td colspan="10">
          <div class="flex-between">
            <div>
              <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
              <span class="MR5 CL5" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
              <span>{{ item.name }}</span>
              <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
            </div>
            <div class="flex-between" style="margin-left: 10px">
              <span class="QHset" style="white-space: nowrap" @click="$refs.setQualification.hiUpdete(item.id)" v-if="isAuth"> 修改 </span>
              <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              <span class="QHset CL1" style="white-space: nowrap" @click="deleteData(item.id)" v-if="isAuth"> 删除 </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </Modal>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "车厢详情",
      show: false,
      isAuth: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:唤起修改
    // +----------------------------------------------------------------------
    hiPop(e, isAuth) {
      this.isAuth = isAuth;
      this.$loading(true);
      this.$api.getBoxDetailed({ id: e.id }).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },

  },
};
</script>
